// @flow

import type {RequestParameters} from '../util/ajax';
import {makeRequest} from '../util/ajax';
import urls from '../util/urls';
import config from '../util/config';

type DwellTimesOptions = {
    token: ?string,
    placeId: string,
};

/**
 * DwellTimes
 */
export const DwellTimes = {
    /**
     * Gets the dwell times about a single place.
     * @param {DwellTimesOptions} options Options
     * @param {string} [options.token] Authentication token.
     * @param {string} [options.placeId] Place Id. Required.
     *
     * @returns Promise<any>
     *
     * @example
     * const dwellTimesPromise = TrimbleMaps.DwellTimes.getGlobalDwellTimes({
     *   token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9',
     *   placeId: '0xlM0l28x0LEiCiOPrHt-_WQ'
     * });
     */
    getGlobalDwellTimes,
};

/**
 * @private
 *
 * Gets dwell tiems
 * @param {DwellTimesOptions} options Options
 *
 * @returns Promise<any>
 */
function getGlobalDwellTimes(options: DwellTimesOptions): Promise<any> {
    // call https://authws-qa.alk.com/api/v1/trimbleid/authenticate
    // to get authToekn like 'xqmyskevx89f89vbpy82fbblw25y8dca'
    // TrimbleMaps.APIToken = 'xqmyskevx89f89vbpy82fbblw25y8dca';
    options = options || {};
    const placeId = options.placeId;
    const token = options.token || config.API_TOKEN;
    if (typeof placeId === 'undefined' || placeId === null || placeId.length === 0) {
        throw new Error('Place Id is required.');
    }
    if (typeof token === 'undefined' || token === null || token.length === 0) {
        throw new Error('Authentication token is required.');
    }
    const url = `${urls.DWELL_TIME_URL}?trimblePlaceIds=${placeId}`;
    const request: RequestParameters = {
        url,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization':  config.API_TOKEN ? `bearer ${token}` : `jsonWebToken=${token}`
        }
    };
    return new Promise((resolve) => {
        makeRequest(request, (_, resp: any) => {
            resolve(resp);
        });
    });
}
